module.exports = __webpack_public_path__ + "img/microsoft.d025f60f.svg";